export enum PreferencesSurveySource {
    ONBOARDING = 1,
    AFTER_LEAD = 2,
    PREFERENCES = 3,
    CRM = 4,
    HOME_MATCH = 5,
    FOR_YOU_BANNER = 6,
    FOR_YOU_LANDING = 7,
    REGISTRATION_RP = 8
}
export enum PreferencesSurveySource {
    ONBOARDING = 1,
    AFTER_LEAD = 2,
    PREFERENCES = 3,
    CRM = 4,
    HOME_MATCH = 5,
    FOR_YOU_BANNER = 6,
    FOR_YOU_LANDING = 7,
    REGISTRATION_RP = 8
}
